export default __webpack_public_path__ + "static/media/fridge1-before1-480w.10a3c9b1.png";